import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #ccc;
  padding: 20px 15px 25px 15px;
  min-height: 280px;
`;
